import { computed, unref, type Ref } from 'vue';
import { CustomerRoles } from '~/utils/roles';

export function useCustomerAccess(rolesInput: Ref<string | undefined | null> | string | undefined | null) {
  const roles = computed(() => {
    const val = unref(rolesInput);
    if (typeof val !== 'string' || !val) return [];
    return val.split(',').filter(Boolean).map(r => r.trim());
  });

  const hasPremiumAccess = computed(() => roles.value.includes(CustomerRoles.Premium));
  
  const hasIntermediateAccess = computed(() => 
    roles.value.includes(CustomerRoles.Intermediate) || hasPremiumAccess.value
  );
  
  const hasBasicAccess = computed(() => 
    roles.value.includes(CustomerRoles.Basic) || hasIntermediateAccess.value
  );

  return {
    hasBasicAccess,
    hasIntermediateAccess,
    hasPremiumAccess
  };
}